export default __webpack_public_path__ + "static/media/1469.346ffc7a.png";